<template>
	<div class="content">
		<div class="head">
			<div class="heads" @click="shouye">返回首页</div>
		</div>
		<div class="cl w">
			<div class="mw">
				<div class="searchform">
					<img src="../../assets/logo_sc_s.png" class="logo_sc_s" alt="">
					<div class="td">
						<div class="scform_tb">
							<el-radio v-model="type" @change="radios" :label="1">博客</el-radio>
							<el-radio v-model="type" @change="radios" :label="2">帖子</el-radio>
						</div>
						<div style="display: flex;align-items: center;margin-top: 5px">
							<el-input placeholder="请输入搜索内容" size="small" v-model="search"></el-input>
							<el-button type="primary" size="small" style="margin-left: 10px;" @click="user_search">搜索</el-button>
						</div>
					</div>
				</div>
				
				<div class="tl">
					<div class="sttl mbn">
						结果：找到“{{search}}”相关内容 {{list.length}} 个
					</div>
				</div>
				
				<div class="list" v-for="(item,i) in list" @click="detail(item.id)" :key="i">
					<div class="xs3">{{item.title}}</div>
					<div class="xg1">{{item.show}}次查看</div>
					<div class="p">
						<span class="p01">{{item.createTime}}</span>
						<span class="p02">  -  {{item.nickname}}</span> 
			<!-- 			<span class="p03">  -  今日焦点</span> -->
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import { user_search } from "@/api/boke"
	export default {
		data(){
			return{
				type:1,//1博客 帖子
				search:'',
				list:[],
			}
		},
		mounted(){
			
		},
		methods:{
			detail(id){
				if(this.type==1){
					this.$router.push({
						path:"/bokedetail",
						query:{
							id:id
						}
					})
				}
				if(this.type==2){
					this.$router.push({
						path:"/forumdetail",
						query:{
							id:id
						}
					})
				}
			},
			radios(e){
				this.type = e
				this.user_search()
			},
			user_search(){
				if(!this.search){
					this.$message.error("请输入搜索内容");
					return;
				}
				user_search({
					type:this.type,
					search:this.search
				}).then(res=>{
					console.log("检索成功",res.data);
					this.list = res.data
				}).catch(()=>{
					
				})
			},
			shouye(){
				this.$router.push({
					path:"/portal"
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	::veep .zz_header_bar{
		display: none!important;
	}
	.list{
		width: 860px;
		margin-top: 20px;
		cursor: pointer;
		.p{
			display: flex;
			align-items: center;
			font-size: 12px;
			.p01{
				color: #3A8000;
			}
			.p02,.p03{
				color: #666;
				margin-left: 5px;
				text-decoration: underline;
			}
		}
		.xg1{
			color: #999;
			font-size: 14px;
			margin-top: 4px;
			margin-bottom: 4px;
		}
		.xs3{
			font-size: 14px;
			color: #00C;
			    text-decoration: underline;
			    font-weight: 400;
		}
	}
	.sttl{
		margin: 10px 0;
		    padding: 5px;
		    border-bottom: 1px solid #CCC;
		    background: #F5F5F5;
			font-size: 14px;
			font-weight: bold;
	}
	.mbn {
	    margin-bottom: 5px !important;
	}
	.scform_form{
		width: 587px;
		height: 35px;
		background: url("../../assets/searchbar.png") repeat-x 0 0;
		.td_srchtxt{
			width: 480px;
			height: 35px;
			background: url("../../assets/searchbar.png") no-repeat 0 -35px;
		}
		#scform_srchtxt {
		    padding: 0 10px;
		    width: 460px;
		    background: transparent;
		    outline: none;
			color: #999;
		}
	}
	.head{
		width: 100%;
		height:28px;
		line-height: 28px;
		padding: 0 15px;
		border-bottom: 1px solid #EFEFEF;
		    background: #F2F2F2;
			.heads{
				color: red;
				font-size: 12px;
				cursor: pointer;
			}
	}
	.td{
		width: 587px;
		height: 60px;
		.scform_tb{
			width: 100%;
			height: 26px;
			display: flex;
			align-items: center;
			.scform_tbs{
				color: #369;
				font-size: 12px;
				margin-right: 20px;
				height: 100%;
				line-height: 26px;
			}
			.scform_tbs:hover{
				color: #FFA07A;
			}
			.select{
				color: #333;
				font-weight: bold;
			}
		}
	}

	.content{
		width: 100%;
		height: 100vh;
		background: #fff;
	}
	.searchform{
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		.logo_sc_s{
			width:240px;
			height: 60px;
			margin-right: 20px;
		}
	}
	.w{
		margin: 0 20px;
		.mw{
			width: 100%;
			    float: none;
				padding-top: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/search.vue